import React from 'react';
import PropTypes from 'prop-types';

import FixedTooltipPortal from 'dpl/common/tooltip/components/FixedTooltipPortal';

import LocationAndPickup from '../shared/LocationAndPickup';

export default function LocationMobileMenu({ isOpen, closeModal }) {
  return (
    <FixedTooltipPortal
      className="LocationMobileMenu pt5 ph5 bg-white no-scrollbars b--transparent"
      isVisible={isOpen}
      style={{ maxHeight: '85vh' }}
      onCloseClick={closeModal}
    >
      <LocationAndPickup />
    </FixedTooltipPortal>
  );
}

LocationMobileMenu.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired
};
